import { TablePagination } from "@mui/material";
import { BaseListModal } from "../../../../../../common/components/base_list_modal";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { ObraInformacoes } from "../../../../domain/models/obra_informacoes";
import { StyledDataGrid } from "../../Obras_concretagem/components/styled_data_grid";
import { PaginationProperties } from "../../../../../../common/utils/pagination_property";
import { GridColDef } from "@mui/x-data-grid-pro";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * ObraInformacoesListaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  data: Date | null;
  informacoes: string | null;
  columns: GridColDef[];
  items: ObraInformacoes[];
  pagination: PaginationProperties;
  onClose: () => void;
  onNewItem: () => void;
  onDataChange: (data: Date | null) => void;
  onInformacoesChange: (informacoes: string | null) => void;
  onClearFilters: () => void;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export const ObraInformacoesListaModal = ({
  open,
  saving,
  loading,
  data,
  informacoes,
  columns,
  items,
  pagination,
  onClose,
  onNewItem,
  onDataChange,
  onInformacoesChange,
  onClearFilters,
  onPageChange,
  onRowsPerPageChange,
}: Props) => {
  return (
    <BaseListModal
      open={open}
      saving={saving}
      loading={loading}
      title="Informações da Obra"
      onClose={onClose}>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full flex flex-row justify-end items-center">
          <div>
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
              sx={{ px: 2 }}
              onClick={onNewItem}>
              Novo
            </PrimaryButton>
          </div>
        </div>

        <div className="w-full h-[1px] border-t border-t-stone-300 dark:border-t-stone-600" />

        <CascateList title="Informações da Obra">
          <div className="w-full flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <div className="w-full flex grid grid-cols-3 gap-2">
                <div className="col-span-1">
                  <DefaultDatePickerInput
                    label='Data'
                    value={data}
                    onChange={onDataChange} />
                </div>

                <div className="col-span-2">
                  <DefaultInput
                    name='informacoes'
                    label='Informações'
                    value={informacoes}
                    onChangeValue={onInformacoesChange} />
                </div>
              </div>

              <div className="flex flex-row justify-end">
                <div className="w-[180px]">
                  <PrimaryButton
                    startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                    buttonColor="yellow"
                    onClick={onClearFilters}>
                    Limpar filtros
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </CascateList>

        <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
          <StyledDataGrid
            tableName="obras_informacoes_gerais_6"
            disableColumnMenu={false}
            getRowId={(row: ObraInformacoes) => row.idObraInformacoes}
            getRowHeight={() => 'auto'}
            columns={columns}
            loading={loading}
            height='43vh'
            rows={items}
            rowCount={items.length}
            pageSizeOptions={[100]}
            paginationMode="server"
            paginationModel={{
              page: pagination.page,
              pageSize: pagination.rowsPerPage,
            }}
          />

          <TablePagination
            component="div"
            count={pagination.totalItems}
            page={pagination.page - 1}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[100]}
            onPageChange={(_, p) => onPageChange(p)}
            onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))}
          />
        </div>
      </div>
    </BaseListModal>
  );
}